(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // layout/theme.liquid's first <head> script strips `#contact_form` from the URL before the
    // browser can natively jump to it (see the comment there for why the native jump lands in
    // blank space on this theme's >=990px layout) and leaves window.__ofScrollToContactForm as
    // the signal that a footer newsletter post just landed here. With no native jump to correct,
    // this only needs to do the one real scroll.
    if (!window.__ofScrollToContactForm) return;

    function scrollToContactForm() {
      var target = document.getElementById('contact_form');
      var pageWrapper = document.querySelector('.page-wrapper');
      if (!target || !pageWrapper) return;

      var header = document.querySelector('.site-header');
      var offset = header ? header.getBoundingClientRect().height : 0;
      var targetTop = target.getBoundingClientRect().top + pageWrapper.scrollTop - offset;

      pageWrapper.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
    }

    window.requestAnimationFrame(scrollToContactForm);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', scrollToContactForm, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-section-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(nav) {
      if (nav.dataset.giftSectionNavReady === 'true') return;
      nav.dataset.giftSectionNavReady = 'true';

      var spacer = nav.previousElementSibling;
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
      var stages = links.map(function (link) {
        return document.querySelector(link.getAttribute('href'));
      }).filter(Boolean);
      var header = document.querySelector('.site-header');
      // Horizon's base.css hands real scrolling off to `.page-wrapper` at >=990px (html/body
      // get `overflow: hidden`), so a bare `window` scroll listener alone never fires there —
      // same fix as assets/header-immersive.js's initScrollOpacity and the old
      // gift-theme-badge's scroll-spy.
      var pageWrapper = document.querySelector('.page-wrapper');
      var frame = 0;

      if (!links.length || !stages.length) return;

      function update() {
        frame = 0;
        var headerHeight = header ? header.getBoundingClientRect().height : 0;

        // Fakes `position: sticky` (see file comment for why real sticky/fixed don't work
        // here): pin once the spacer's own in-flow position has scrolled up under the header,
        // unpin if scrolled back above it.
        if (spacer) {
          var shouldPin = spacer.getBoundingClientRect().top <= headerHeight;
          if (shouldPin !== nav.classList.contains('is-pinned')) {
            nav.classList.toggle('is-pinned', shouldPin);
            spacer.classList.toggle('is-active', shouldPin);
          }
        }

        var probeY = headerHeight + nav.getBoundingClientRect().height + 24;
        var activeStage = stages[0];
        stages.forEach(function (stage) {
          if (stage.getBoundingClientRect().top <= probeY) activeStage = stage;
        });
        links.forEach(function (link) {
          if (link.getAttribute('href') === '#' + activeStage.id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }

      function requestUpdate() {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      }

      function scrollToStage(stage) {
        // `.page-wrapper` is only the real scroll container at >=990px (assets/base.css) —
        // below that breakpoint html/body scroll normally and `.page-wrapper` itself doesn't
        // move, so calling scrollTo()/scrollTop on it here would silently no-op on mobile.
        // Same breakpoint check layout/theme.liquid's own scrollingElement workaround uses.
        var isDesktopScroll = pageWrapper && window.matchMedia('(min-width: 990px)').matches;
        var scroller = isDesktopScroll ? pageWrapper : window;
        var currentTop = isDesktopScroll ? pageWrapper.scrollTop : window.scrollY;
        var offset = (header ? header.getBoundingClientRect().height : 0) + nav.getBoundingClientRect().height;
        var targetTop = stage.getBoundingClientRect().top + currentTop - offset;
        var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        if (scroller.scrollTo) {
          scroller.scrollTo({ top: targetTop, behavior: behavior });
        } else {
          scroller.scrollTop = targetTop;
        }
      }

      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var hash = link.getAttribute('href');
          var stage = document.querySelector(hash);
          if (!stage) return;
          event.preventDefault();
          scrollToStage(stage);
          if (window.history.pushState) window.history.pushState(null, '', hash);
          else window.location.hash = hash;
        });
      });

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      window.addEventListener('orientationchange', requestUpdate);
      window.addEventListener('pageshow', requestUpdate);
      window.addEventListener('hashchange', requestUpdate);
      if (pageWrapper) pageWrapper.addEventListener('scroll', requestUpdate, { passive: true });
      requestUpdate();

      if (window.location.hash) {
        var initialStage = stages.filter(function (stage) {
          return '#' + stage.id === window.location.hash;
        })[0];
        if (initialStage) {
          window.requestAnimationFrame(function () {
            scrollToStage(initialStage);
          });
        }
      }
    }

    function initAll() {
      document.querySelectorAll('.gift-section-nav').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var nav = event.target.querySelector && event.target.querySelector('.gift-section-nav');
      if (nav) init(nav);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-stage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stageStates = new Map();

    function applySlide(stage, slide, index, total) {
      var panel = stage.querySelector('.story-panel');
      if (!panel || !slide) return;

      var img = panel.querySelector(':scope > img');
      var title = panel.querySelector('.story-title');
      var line = panel.querySelector('.story-line');
      var cta = panel.querySelector('.story-cta');
      var copy = panel.querySelector('.story-copy');
      var status = panel.querySelector('.panel-status');

      panel.classList.add('is-switching');
      if (img) {
        // `image_tag` (Liquid) renders this img with a `srcset` for the *first* slide's
        // image — browsers resolve the actually-displayed image from `srcset` over a plain
        // `src` whenever both are present, so setting only `.src` here silently never
        // changed what was on screen (confirmed 2026-07-14: `.src` updated correctly,
        // `.currentSrc` — what's actually painted — stayed on the first slide's srcset
        // candidates). Drop `srcset`/`sizes` on first swap so `.src` alone drives the image
        // from here on.
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = slide.image;
        img.alt = slide.alt || '';
      }
      panel.setAttribute('data-tone', slide.tone || 'light');
      if (copy) copy.setAttribute('data-align', slide.align || 'left');

      if (title) {
        title.textContent = slide.title || '';
        title.hidden = !slide.title;
      }
      if (line) {
        line.textContent = slide.line || '';
        line.hidden = !slide.line;
      }
      if (cta) {
        cta.textContent = slide.ctaLabel || '';
        cta.href = slide.ctaHref || '#';
      }
      if (status) {
        var statusText = (slide.title ? slide.title + '. ' : '') + 'Image ' + (index + 1) + ' of ' + total + '.' + (slide.ctaLabel ? ' ' + slide.ctaLabel : '');
        if (status.textContent !== statusText) status.textContent = statusText;
      }

      window.requestAnimationFrame(function () {
        panel.classList.remove('is-switching');
      });
    }

    function findSlideIndex(slides, variantId, productId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].variantId) === String(variantId)) return i;
      }
      for (var j = 0; j < slides.length; j++) {
        if (String(slides[j].productId) === String(productId)) return j;
      }
      return -1;
    }

    function initStage(stage) {
      if (stage.dataset.giftStageReady === 'true') return;
      stage.dataset.giftStageReady = 'true';

      var payloadScript = stage.querySelector('[data-gift-stage-payload]');
      if (!payloadScript) return;

      var payload;
      try {
        payload = JSON.parse(payloadScript.textContent);
      } catch (error) {
        return;
      }

      var slides = payload.slides || [];
      if (!slides.length) return;

      var state = { slides: slides, index: 0 };
      stageStates.set(stage, state);

      var panel = stage.querySelector('.story-panel');
      var prev = panel && panel.querySelector('.story-arrow--prev');
      var next = panel && panel.querySelector('.story-arrow--next');

      function step(direction) {
        state.index = (state.index + direction + slides.length) % slides.length;
        applySlide(stage, slides[state.index], state.index, slides.length);
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      applySlide(stage, slides[0], 0, slides.length);
    }

    function initAll() {
      document.querySelectorAll('.gift-stage').forEach(initStage);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var stage = event.target.querySelector && event.target.querySelector('.gift-stage');
      if (stage) initStage(stage);
    });

    document.addEventListener('of-product-preview', function (event) {
      var card = event.detail && event.detail.card;
      if (!card) return;
      var stage = card.closest('.gift-stage');
      if (!stage) return;
      var state = stageStates.get(stage);
      if (!state) return;
      var productId = card.getAttribute('data-product-id');
      var index = findSlideIndex(state.slides, event.detail.variantId, productId);
      if (index === -1) return;
      state.index = index;
      applySlide(stage, state.slides[index], index, state.slides.length);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(hero) {
      if (hero.dataset.heroCarouselReady === 'true') return;
      hero.dataset.heroCarouselReady = 'true';

      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      if (slides.length < 2) return;

      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
      var prevButton = hero.querySelector('[data-hero-prev]');
      var nextButton = hero.querySelector('[data-hero-next]');
      var current = 0;
      var timer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function notifyHeader() {
        // header-immersive.js only re-checks data-header-ink on scroll/resize/load;
        // a slide switch changes which zone is under the header without either firing.
        window.dispatchEvent(new Event('resize'));
      }

      function showSlide(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach(function (dot, i) {
          var active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        notifyHeader();
      }

      function stopTimer() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function startTimer() {
        stopTimer();
        if (!reduceMotion) timer = window.setInterval(function () { showSlide(current + 1); }, 6800);
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          showSlide(current - 1);
          startTimer();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          showSlide(current + 1);
          startTimer();
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          showSlide(Number(dot.getAttribute('data-hero-dot')));
          startTimer();
        });
      });

      // Slides are absolutely-positioned/cross-faded, not a native scroll track, so unlike
      // community-style-gallery.js's `.style-track` (plain overflow-x scroll) there's no
      // browser-native swipe to fall back on — touch gesture handling has to be built by hand.
      var touchStartX = null;
      var touchStartY = null;
      var SWIPE_THRESHOLD = 40;

      hero.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length !== 1) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      hero.addEventListener(
        'touchend',
        function (event) {
          if (touchStartX === null) return;
          var touch = event.changedTouches[0];
          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;
          touchStartX = null;
          touchStartY = null;
          // Ignore short taps (let CTA/dot/arrow clicks resolve normally) and drags that are
          // more vertical than horizontal (let the page scroll instead of hijacking it).
          if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;
          showSlide(deltaX < 0 ? current + 1 : current - 1);
          startTimer();
        },
        { passive: true }
      );

      hero.addEventListener('mouseenter', stopTimer);
      hero.addEventListener('mouseleave', startTimer);
      hero.addEventListener('focusin', stopTimer);
      hero.addEventListener('focusout', startTimer);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopTimer(); else startTimer();
      });

      startTimer();
    }

    function initAll() {
      document.querySelectorAll('.hero[data-section-id]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var hero = event.target.querySelector && event.target.querySelector('.hero[data-section-id]');
      if (hero) init(hero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signals-taxonomy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(nav) {
      if (nav.dataset.signalsTaxonomyReady === 'true') return;
      nav.dataset.signalsTaxonomyReady = 'true';

      initPinning(nav);

      var buttons = Array.prototype.slice.call(nav.querySelectorAll('[data-view]'));
      var archive = document.querySelector('.signals-archive');
      if (!buttons.length || !archive) return;

      function applyView(view) {
        archive.classList.toggle('is-grid', view === 'grid');
        buttons.forEach(function (button) {
          button.setAttribute('aria-pressed', String(button.getAttribute('data-view') === view));
        });
      }

      function setView(view) {
        applyView(view);
        if (window.location.protocol === 'file:') return;
        var params = new URLSearchParams(window.location.search);
        if (view === 'grid') {
          params.set('view', 'grid');
        } else {
          params.delete('view');
        }
        var query = params.toString();
        history.replaceState({}, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          setView(button.getAttribute('data-view'));
        });
      });

      var initialParams = new URLSearchParams(window.location.search);
      applyView(initialParams.get('view') === 'grid' ? 'grid' : 'index');
    }

    function initPinning(nav) {
      var spacer = nav.previousElementSibling;
      if (!spacer || !spacer.hasAttribute('data-signals-taxonomy-spacer')) return;

      function headerOffset() {
        var value = getComputedStyle(document.documentElement).getPropertyValue('--signals-header-h');
        return parseFloat(value) || 0;
      }

      function update() {
        var shouldPin = spacer.getBoundingClientRect().top <= headerOffset();
        var isPinned = nav.classList.contains('is-pinned');
        if (shouldPin && !isPinned) {
          spacer.style.height = nav.getBoundingClientRect().height + 'px';
          nav.classList.add('is-pinned');
        } else if (!shouldPin && isPinned) {
          nav.classList.remove('is-pinned');
          spacer.style.height = '';
        }
      }

      // Horizon routes real scrolling through `.page-wrapper` (own internal
      // overflow) at some viewport widths and leaves it to the plain window
      // at others (see sections/gift-theme-badge.liquid's file comment for
      // the same architecture note). `scroll` events don't bubble from a
      // scrolled element to `window`, so listening on `window` alone missed
      // every scroll while `.page-wrapper` was the real scroll container —
      // found live 2026-07-22 testing at desktop width, where the nav never
      // pinned at all despite working correctly at the narrower width this
      // was first tested at. Listening on both covers either mode; only one
      // of them actually fires scroll events at any given time.
      window.addEventListener('scroll', update, { passive: true });
      var pageWrapper = document.querySelector('.page-wrapper');
      if (pageWrapper) {
        pageWrapper.addEventListener('scroll', update, { passive: true });
      }
      window.addEventListener('resize', function () {
        if (nav.classList.contains('is-pinned')) {
          nav.classList.remove('is-pinned');
          spacer.style.height = '';
        }
        update();
      });
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-signals-taxonomy]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var nav = event.target.querySelector && event.target.querySelector('[data-signals-taxonomy]');
      if (nav) init(nav);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
